import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useEmbeddedPage } from "@/components/shared/EmbeddedPageContext";

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  className?: string;
}

const PageHeader = ({ title, description, actions, className }: PageHeaderProps) => {
  // Inside a SideTabsPage the page already has a title, so this becomes a section heading.
  const embedded = useEmbeddedPage();
  const Heading = embedded ? "h2" : "h1";

  return (
    <div className={cn("flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between", className)}>
      <div>
        <Heading
          className={cn(
            "font-heading font-bold tracking-tight text-foreground",
            embedded ? "text-xl" : "text-2xl lg:text-3xl",
          )}
        >
          {title}
        </Heading>
        {description && <p className="text-muted-foreground text-sm mt-1">{description}</p>}
      </div>
      {actions && <div className="flex w-full shrink-0 flex-wrap items-center gap-2 sm:w-auto">{actions}</div>}
    </div>
  );
};

export default PageHeader;
